module.exports = __webpack_public_path__ + "SC03-52.4cf6523e.png";